
import { Component, Vue } from 'vue-property-decorator'
import { moneyFormat } from '@/utils/util'
@Component({
  name: 'HandleFlowDialog'
})
export default class HandleFlowDialog extends Vue {
  showDialog = false
  title = '标题'
  message = '提示信息'
  operateType = undefined
  isRequired = false
  isNumberInput = false
  labelType = 1
  // 备注
  remark = ''

  moneyFormat=moneyFormat

  // input输入限制 不能为负数
  formatterInput (value) {
    if(parseFloat(value)>=0){
      return value
    }else {
      return ''
    }
  }

  show ({ title, message, operateType, isRequired, isNumberInput }) {
    this.remark = ''
    this.title = title
    this.message = message
    this.operateType = operateType
    this.isRequired = isRequired
    this.isNumberInput = isNumberInput
    this.showDialog = true
    if(this.title == '确认收款') {
      this.labelType = 1
    } else if (this.title == '确认付款') {
      this.labelType = 2
    } else {
      this.labelType = 3
    }
    // 重置表单
    // this.remark = '';
    this.$refs.vanForm && (this.$refs.vanForm as any).resetValidation('remark')
  }

  onBeforeClose(action, done){
    if(action==='confirm'){
      if(this.isNumberInput && !this.remark) {
        this.$toast('请输入金额')
        done(false)
        return
      }
      (this.$refs.vanForm as any).validate().then(()=>{
        this.$emit('confirm', { remark: this.remark, operateType: this.operateType })
        done()
      }).catch(()=>{
        done(false)
      })
    }else {
      done()
    }
  }
}
